import FixtureGroupForElement from "../../FixtureGroupForElement";
import ElementDetailsBar from "../ElementDetailsBar";
import { ElementCardFixturesProps } from "./types";

const ElementCardFixtures = ({
  eventId,
  elementId,
}: ElementCardFixturesProps) => (
  <ElementDetailsBar>
    {eventId ? (
      <FixtureGroupForElement eventId={eventId} elementId={elementId} />
    ) : (
      "-"
    )}
  </ElementDetailsBar>
);

export default ElementCardFixtures;
